import notificationService from '@/services/notificationService';
import * as msal from '@azure/msal-browser';
import { AuthConfig, AzureADOptions } from "../installationConfig";

export default class AuthenticationService {
    public getUser(): msal.AccountInfo | undefined {
        const accounts = AuthConfig.msalInstance!.getAllAccounts();

        if (accounts.length > 0) {
            return accounts[0];
        }
        return undefined;
        // throw Error('No user found');
    }

    public isAdmin() {
        return true;
    }

    public isNotInRole(roles: string[]) {
        const user = this.getUser();

        if (!user) {
            return false;
        }

        const isInRole = roles.some((role) => this.hasRole(role));
        return !isInRole;
    }

    public canSeeSensitiveInfo() {
        return true;
    }

    public isInAnyRole(roles: string[]) {
        const user = this.getUser();

        if (!user) {
            return false;
        }

        return roles.some((role) => this.hasRole(role));
    }

    public hasRole(role: string): boolean {
        const user = this.getUser();

        if (user && (user.idTokenClaims as any).groups
            && ((user.idTokenClaims as any).groups as string[]).includes(role)) {
            return true;
        }

        return false;
    }

    public async signIn() {
        try {
            await AuthConfig.msalInstance!.handleRedirectPromise();

            const accounts = AuthConfig.msalInstance!.getAllAccounts();
            if (accounts.length > 0) {
                // user logged in
                return;
            }
            AuthConfig.msalInstance!.loginRedirect({
                scopes: [
                    'profile',
                    'openid',
                    'email',
                    'User.Read.All',
                    'Group.Read.All',
                    'GroupMember.Read.All',
                    'Directory.Read.All',
                    `api://${AzureADOptions.clientId}/all`,
                ],
            });
        } catch (err) {
            alert('failed to login user');
        }
    }

    public async getAccessTokenForGraph() {
        try {
            const tokenResult = await AuthConfig.msalInstance!.acquireTokenSilent({
                scopes: ['User.Read.All', 'Group.Read.All', 'GroupMember.Read.All', 'Directory.Read.All'],
                account: this.getUser(),
            });
            return tokenResult.accessToken;
        } catch (error) {
            notificationService.showErrorMessage("Exception GetAccessTokenForGraph: " + error.message);
            await AuthConfig.msalInstance!.acquireTokenRedirect({
                scopes: ['User.Read.All', 'Group.Read.All', 'GroupMember.Read.All', 'Directory.Read.All'],
            });
        }
    }

    public async getAccessToken() {
        try {
            const tokenResult = await AuthConfig.msalInstance!.acquireTokenSilent({
                scopes: [`api://${AzureADOptions.clientId}/all`],
                account: this.getUser(),
            });

            return tokenResult.accessToken;
        } catch (error) {
            notificationService.showErrorMessage("Exception GetAccessToken: " + error.message);

            await AuthConfig.msalInstance!.acquireTokenRedirect({
                scopes: [`api://${AzureADOptions.clientId}/all`],
            });
        }
    }

    public signOut() {
        AuthConfig.msalInstance!.logoutRedirect();
    }
}
